var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Section',{attrs:{"options":_vm.computedOptions.sectionOptions}},[_c('LocalizedContent',{attrs:{"localizedContent":_vm.labels.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }